import React from 'react';
/**
 * `ButtonCommand` is a thin styled wrapper around the shared `Button`
 * component.
 *
 * It applies secondary button styling plus the `cms-btn-command` CMS hook
 * class. It is generally used for inline or non-primary actions.
 */

import Button from '../Button/Button';

type ButtonCommandProps = {
  name: string;
  text: string;
  disabled?: boolean;
  onClick: (callback?: () => void) => void;
  waitText?: string;
  waitValue?: boolean;
  waitOnClick?: boolean;
  additionalClassNames?: string;
  //ref?: LegacyRef<HTMLButtonElement>;
};

export const ButtonCommand = ({
  name,
  text,
  disabled,
  onClick,
  waitText,
  waitValue,
  waitOnClick,
  additionalClassNames //ref
}: ButtonCommandProps): JSX.Element => {
  let classes = 'button button-secondary';

  if (additionalClassNames) {
    classes += ` ${additionalClassNames}`;
  }

  classes += ' cms-btn-command';

  return (
    <Button
      name={name}
      text={text}
      disabled={disabled}
      className={classes}
      onClick={onClick}
      waitValue={waitValue}
      waitText={waitText}
      waitOnClick={waitOnClick}
      //ref={ref}
    />
  );
};
